export const getHeadsUpCopy = (editedCount) => {
    const count = Number(editedCount) || 0;
    if (count === 0) {
        return {
            title: 'No products have been hand-tuned',
            description:
                'Your new default will roll out to every product still on auto. None of your products have manual edits to preserve.',
            overwriteDescription:
                'All products will use the new default. There are no hand-edited products to reset.',
        };
    }

    if (count === 1) {
        return {
            title: "You've hand-tuned 1 product",
            description:
                'Your new default rolls out to every product still on auto. What should we do with the one you edited yourself?',
            overwriteDescription:
                '1 hand-edited product gets reset to the new default too. This can\u2019t be undone.',
        };
    }

    return {
        title: `You've hand-tuned ${count} products`,
        description:
            'Your new default rolls out to every product still on auto. What should we do with the ones you\u2019ve edited yourself?',
        overwriteDescription: `${count} hand-edited products get reset to the new default too. This can\u2019t be undone.`,
    };
};
